export default function create_default_template() {
  // 海报默认模板
  return {
    // 职位图文详情模板
    imageText: {
      height: 667, // 海报宽度
      width: 375, // 海报高度
      in: 'move',
      pages: {
        bgcol: 'rgba(255,255,255,1)',
        selectBgType: '1', // 1: 背景色 2：背景图片
        cmps: [
          {
            tid: '1csmfp497a9s00', // 挂件唯一id
            lock: false, // 当前挂件是否锁定
            hidden: false,
            style: {
              position: 'absolute',
              width: 373.896, // 挂件宽度
              height: 515.92, // 挂件高度
              left: 1, // 挂件定位
              top: -1, // 挂件定位
              'border-radius': 17, // 圆角
              'border-width': 0,
              'border-style': 'solid',
              rotate: 0,
              transform: 'rotate(0deg)',
              'border-color': '',
              'clip-path': 'none',
              opacity: 1 // 透明度
            },
            file: { // type为basic_image是需要的图片信息
              key: '/img/poster/template1.png', // 图片地址
              filtereffect: 'original',
              a: null,
              server: '',
              orikey: '/img/poster/template1.png',
              link: 'https://img01.71360.com/w3/jj54ej/20231107/cfac6e6996d139b7e6d17127afb74466.png'
            },
            link: null,
            filterType: 0,
            clipShape: '',
            fit: 'cover',
            cmpType: 'image',
            type: 'basic_image', // 挂件类型 basic_image：图片 basic_text：文本
            name: '图片8',
            positionInfoList: [], // 职位配置信息
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            canResize: false
          },
          {
            autoFixLayoutSize: true,
            cmpType: 'text',
            hidden: false,
            imageLink: '',
            isEditing: false,
            link: null,
            lock: false,
            mask: false,
            name: '文字2',
            positionInfoList: [
                '招聘类别',
                '工作性质',
                '工作地点',
                // '招聘人数',
                // '薪资范围',
                
                // '需求部门',
                // '面试站点',
                // '工作经验',
                // '学历要求',
                // '招聘负责人'
              ],
            style: { // 该对象样式可直接用到style上
              background: 'transparent',
              color: 'rgba(255,255,255,1)',
              'font-family': 'font-25',
              'font-size': 14,
              font_family: 'font-25',
              height: 'auto',
              left: 45,
              'letter-spacing': 0,
              'line-height': 18,
              opacity: 1,
              position: 'absolute',
              rotate: 0,
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              top: 171,
              transform: 'rotate(0deg)',
              width: 200
            },
            text: '<span style="color: rgb(255, 255, 255);">默认类别 | 全职 | 全国 </span>', // 文本内容
            textType: 'positionInfo', // 文本类型  companyName:企业简称， gatewayName: 门户名称，userName：用户姓名，positionName：职位名称，positionInfo：职位信息
            tid: '2795gfwpgefw00',
            type: 'basic_text',
            _style: { // pc端样式存储对应样式信息，移动用不到
              'font-size': 14,
              font_family: 'font-25',
              'line-height': 18,
              width: 200
            },
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            canResize: true,
            clipShape: '',
            cmpType: 'image',
            file: {
              a: null,
              filtereffect: 'original',
              key: 'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp',
              orikey:
                'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp',
              server: ''
            },
            filterType: 0,
            fit: 'cover',
            hidden: false,
            link: null,
            lock: false,
            name: '图片3',
            positionInfoList: [],
            imgType: 'qrCode',
            style: {
              'border-color': '',
              'border-radius': 0,
              'border-style': 'solid',
              'border-width': 0,
              'clip-path': 'none',
              height: 131,
              left: 45,
              opacity: 1,
              position: 'absolute',
              rotate: 0,
              top: 270,
              transform: 'rotate(0deg)',
              width: 131
            },
            tid: '510df97ra58000',
            type: 'basic_image',
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            autoFixLayoutSize: true,
            canResize: false,
            on_double_click: 1,
            cmpType: 'text',
            hidden: false,
            imageLink: '',
            isEditing: false,
            link: null,
            lock: false,
            mask: false,
            name: '文字4',
            positionInfoList: [],
            style: {
              background: 'transparent',
              color: 'rgba(255,255,255,1)',
              'font-family': 'font-25',
              'font-size': 14,
              font_family: 'font-25',
              height: 36,
              left: 36,
              'letter-spacing': 0,
              'line-height': 18,
              opacity: 1,
              position: 'absolute',
              rotate: 0,
              'text-align': 'center',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              top: 417,
              transform: 'rotate(0deg)',
              width: 144
            },
            text: '<span style="color: rgb(255, 255, 255);">长按识别二维码</span><div><span style="color: rgb(255, 255, 255);">查看更多职位</span></div>',
            textType: '',
            tid: '1b8lv2ne6dmo00',
            type: 'basic_text',
            _style: {
              'font-size': 14,
              font_family: 'font-25',
              'line-height': 18,
              width: 200
            },
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            canResize: true,
            clipShape: '',
            cmpType: 'image',
            file: {
              a: null,
              filtereffect: 'original',
              key: '/img/poster/avatar.svg',
              orikey: '/img/poster/avatar.svg',
              server: '',
              link: 'https://img01.71360.com/w3/jj54ej/20231107/d11943c5ea96545de7a58a4adb5b6e1d.png'
            },
            filterType: 0,
            fit: 'cover',
            hidden: false,
            link: null,
            lock: false,
            name: '图片5',
            positionInfoList: [],
            imgType: 'userProfile',
            style: {
              'border-color': '',
              'border-radius': 100,
              'border-style': 'solid',
              'border-width': 0,
              'clip-path': 'none',
              height: 72,
              left: 40,
              opacity: 1,
              position: 'absolute',
              rotate: 0,
              top: 545,
              transform: 'rotate(0deg)',
              width: 72
            },
            tid: '4emaevnxo0o000',
            type: 'basic_image',
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            autoFixLayoutSize: true,
            canResize: false,
            on_double_click: 1,
            cmpType: 'text',
            hidden: false,
            imageLink: '',
            isEditing: false,
            link: null,
            lock: false,
            mask: false,
            name: '文字6',
            positionInfoList: [],
            style: {
              background: 'transparent',
              color: 'rgba(33,33,33,1)',
              'font-family': 'font-25',
              'font-size': 20,
              font_family: 'font-25',
              height: 'auto',
              left: 125,
              'letter-spacing': 0,
              'line-height': 26,
              opacity: 1,
              position: 'absolute',
              rotate: 0,
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              top: 550,
              transform: 'rotate(0deg)',
              width: 200
            },
            text: '<span style="font-size: 20px; color: rgb(33, 33, 33);">门户名称</span>',
            textType: 'gatewayName',
            tid: 'bfij3vdxfr400',
            type: 'basic_text',
            _style: {
              'font-size': 14,
              font_family: 'font-25',
              'line-height': 18,
              width: 200
            },
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            autoFixLayoutSize: true,
            cmpType: 'text',
            hidden: false,
            imageLink: '',
            isEditing: false,
            link: null,
            lock: false,
            mask: false,
            name: '文字1',
            positionInfoList: [],
            style: {
              background: 'transparent',
              color: 'rgba(255,255,255,1)',
              'font-family': 'font-25',
              'font-size': 30,
              'font-weight': 'bold',
              font_family: 'font-25',
              height: 'auto',
              left: 45,
              'letter-spacing': 0,
              'line-height': 36,
              opacity: 1,
              position: 'absolute',
              rotate: 0,
              'text-align': 'left',
              'font-style': 'normal',
              top: 103,
              transform: 'rotate(0deg)',
              width: 200
            },
            text: '<span style="color: rgb(255, 255, 255);">系统预置职位</span>',
            textType: 'positionName',
            tid: '4l3vc5psv7s000',
            type: 'basic_text',
            _style: {
              'font-size': 30,
              'font-weight': 'bold',
              font_family: 'font-25',
              'line-height': 36,
              width: 200
            },
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            autoFixLayoutSize: true,
            canResize: false,
            on_double_click: 1,
            cmpType: 'text',
            hidden: false,
            imageLink: '',
            isEditing: false,
            link: null,
            lock: false,
            mask: false,
            name: '文字7',
            positionInfoList: [],
            style: {
              background: 'transparent',
              color: 'rgba(33,33,33,1)',
              'font-family': 'font-25',
              'font-size': 14,
              font_family: 'font-25',
              height: 'auto',
              left: 124,
              'letter-spacing': 0,
              'line-height': 18,
              opacity: 1,
              position: 'absolute',
              rotate: 0,
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              top: 591,
              transform: 'rotate(0deg)',
              width: 200
            },
            text: '<span style="color: rgb(33, 33, 33);">让我帮你内推吧~</span>',
            textType: '',
            tid: '3pw822elgt6000',
            type: 'basic_text',
            _style: {
              'font-size': 14,
              font_family: 'font-25',
              'line-height': 18,
              width: 200
            },
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          }
        ]
      },
      selectPosition: '1', // 1:单个职位 2：多个职位
      previewUrl: 'https://zzp-public-1318723636.cos.ap-shanghai.myqcloud.com/zhaopin/123456/2024/06/12/cd322b12b97849ebbebf834975427a3b.png', // 海报预览截图
      posterName: '系统预置海报'
    },
    // 职位详情模板
    detail: {
      width: 375,
      height: 'auto',
      in: 'move',
      selectPosition: '1',
      pages: {
        bgcol: '#fff',
        selectBgType: '2',
        posterType:'detail',
        cmps: [
            {
                tid: '5tebhmn0mmk004',
                lock: true,
                hidden: false,
                style: {
                  position: 'absolute',
                  width: 349.941,
                  height: 523,
                  left: 12,
                  top: 20,
                  'border-radius': 4,
                  'border-width': 0,
                  'border-style': 'solid',
                  rotate: 0,
                  transform: 'rotate(0deg)',
                  'border-color': '',
                  'clip-path': 'none',
                  opacity: 1,
                  background: '#fff'
                },
                link: null,
                filterType: 0,
                clipShape: '',
                cmpType: 'block',
                type: 'basic_block',
                name: '中间背景色块',
                positionInfoList: [],
                isEditing: false,
                autoFixLayoutSize: true,
                shadow: {
                  x: 0,
                  y: 0,
                  blur: 0,
                  color: '#000'
                },
                // qyCodeLayout: 'right',  // left right
                // qyCodelocation: 'top' // top bottom
              },
            {
                autoFixLayoutSize: true,
                cmpType: 'text',
                hidden: false,
                imageLink: '',
                isEditing: false,
                link: null,
                lock: false,
                mask: false,
                name: '文字1',
                positionInfoList: [],
                style: {
                  background: 'transparent',
                  color: 'rgba(255,255,255,1)',
                  'font-family': 'font-25',
                  'font-size': 24,
                  'font-weight': 'bold',
                  font_family: 'font-25',
                  height: 'auto',
                  left: 26,
                  'letter-spacing': 0,
                  'line-height': 36,
                  opacity: 1,
                  position: 'absolute',
                  rotate: 0,
                  'text-align': 'left',
                  'font-style': 'normal',
                  top: 115,
                  transform: 'rotate(0deg)',
                  width: 230
                },
                text: '<span style="color: rgb(0, 0, 0);">系统预置职位</span>',
                textType: 'positionName',
                tid: '4l3vc5psv7s000',
                type: 'basic_text',
                _style: {
                  'font-size': 24,
                  'font-weight': 'bold',
                  font_family: 'font-25',
                  'line-height': 36,
                  width: 230
                },
                shadow: {
                  x: 0,
                  y: 0,
                  blur: 0,
                  color: '#000'
                }
          },
          {
            tid: '9v9t26nyo4k00',
            lock: true,
            hidden: false,
            style: {
              'font-size': 16,
              'line-height': 20,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 26,
              top: 155,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 300,
              color: '#000',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="font-size: 16px;"><img src="/img/poster/icon1.png"/>默认类别&nbsp; &nbsp; &nbsp;<img src="/img/poster/icon2.png"/>全职&nbsp; &nbsp; &nbsp; &nbsp;<img src="/img/poster/icon3.png"/>全国</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字8',
            textType: 'infoIcon',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1
          },
          {
            tid: '12pli3u9bfa800',
            lock: true,
            hidden: false,
            style: {
              'font-size': 20,
              'line-height': 31,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 26,
              top: 185,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: '#165DFF',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="color: #165DFF font-size: 24px; font-weight: bold;">500w-1000w / 年</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字7',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1,
            textType: 'salary'
          },
          {
            tid: '3c0eq1j3hzy000',
            lock: true,
            hidden: false,
            style: {
              'font-size': 14,
              'line-height': 18,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 26,
              top: 230,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 323,
              color: 'rgba(53,53,53,1)',
              background: '#ECEFF6',
              padding: '8px 12px',
              'border-radius': 4,
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="color: rgb(53, 53, 53);">默认类别 | 全职 | 全国 | 默认部门 | 在招若干人 | 面试站点：北京大学站 | 500W-1000W/年 | 1年以上 | 本科 | HR小张.招聘负责人 | 职位类型 | 招聘区域</span>',
            link: null,
            textType: 'positionInfo',
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字9',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [
              '招聘类别',
              '工作地点',
              '招聘人数',
              '薪资范围',
              '工作性质',
              '需求部门',
              '面试站点',
              '工作经验',
              '学历要求',
              '招聘负责人'
            ],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            canResize: false
          },
          {
            tid: '4mx3ge4s8m0000',
            lock: true,
            hidden: false,
            style: {
              'font-size': 20,
              'line-height': 26,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 26,
              top: 325,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: '#000',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="font-size: 20px; font-weight: bold;">工作职责</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字10',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1,
            textType: 'jobResponsibilityTitle'
          },
          {
            tid: '42401v5z9ko000',
            lock: true,
            hidden: false,
            style: {
              'font-size': 14,
              'line-height': 18,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 26,
              top: 360,
              rotate: 0,
              height: 165,
              transform: 'rotate(0deg)',
              width: 331,
              color: '#000',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '本职位为系统预置职位数据，非企业发布的真实职位数据，仅用于企业配置职位详情海报时查看职位字段配置效果；本职位为系统预置职位数据，非企业发布的真实职位数据，仅用于企业配置职位详情海报时查看职位字段配置效果；本职位为系统预置职位数据，非企业发布的真实职位数据，仅用于企业配置职位详情海报时查看职位字段配置效果；本职位为系统预置职位数据，非企业发布的真实职位数据，仅用于企业配置职位详情海报时查看职位字段配置效果；',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字11',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              height: 80,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1,
            canResize: false,
            textType: 'jobResponsibility' // 工作职责内容标志
          },
          {
            tid: '4mx3ge4s8m0002',
            lock: true,
            hidden: false,
            style: {
              'font-size': 20,
              'line-height': 26,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 26,
              top: 540,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: '#000',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="font-size: 20px; font-weight: bold;">任职资格</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字11',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1,
            textType:'qualificationsTitle'
          },
          {
            tid: '42401v5z9ko003',
            lock: true,
            hidden: false,
            style: {
              'font-size': 14,
              'line-height': 18,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 26,
              top: 580,
              rotate: 0,
              height: 165,
              transform: 'rotate(0deg)',
              width: 331,
              color: '#000',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '本职位为系统预置职位数据，非企业发布的真实职位数据，仅用于企业配置职位详情海报时查看职位字段配置效果；本职位为系统预置职位数据，非企业发布的真实职位数据，仅用于企业配置职位详情海报时查看职位字段配置效果；本职位为系统预置职位数据，非企业发布的真实职位数据，仅用于企业配置职位详情海报时查看职位字段配置效果；本职位为系统预置职位数据，非企业发布的真实职位数据，仅用于企业配置职位详情海报时查看职位字段配置效果；',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字11',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              height: 80,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1,
            canResize: false,
            textType: 'qualifications' // 任职资格内容标志
          },
          {
            tid: '5tebhmn0mmk001',
            lock: true,
            hidden: false,
            style: {
                position: 'absolute',
                width: 329.941,
                height: 80,
                left: 22,
                top: 30,
                'border-radius': 4,
                'border-width': 0,
                'border-style': 'solid',
                rotate: 0,
                transform: 'rotate(0deg)',
                'border-color': '',
                'clip-path': 'none',
                'background-color': '#ECEFF6',
                opacity: 1
            },
            file: {
                key: '',
                filtereffect: 'original',
                a: null,
                server: '',
                orikey: ''
            },
            link: null,
            filterType: 0,
            clipShape: '',
            fit: 'cover',
            cmpType: 'image',
            type: 'basic_image',
            name: '二维码区块',
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            blockType: 'qrCodeBlock', // 前端用于二维码模块定位区别
            shadow: {
                x: 0,
                y: 0,
                blur: 0,
                color: '#000'
            }
          },
          {
            tid: '4in6ce6s04o000',
            lock: true,
            hidden: false,
            style: {
              position: 'absolute',
              width: 64,
              height: 64,
              left: 280,
              top: 38,
              'border-radius': 0,
              'border-width': 0,
              'border-style': 'solid',
              rotate: 0,
              transform: 'rotate(0deg)',
              'border-color': '',
              'clip-path': 'none',
              opacity: 1
            },
            file: {
              key: 'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp',
              filtereffect: 'original',
              a: null,
              server: '',
              orikey: 'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp'
            },
            imgType: 'qrCode',
            link: null,
            filterType: 0,
            clipShape: '',
            fit: 'cover',
            cmpType: 'image',
            type: 'basic_image',
            name: '图片4',
            positionInfoList: [],
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            canResize: true,
            blockType: 'qrCodeBlock' // 前端用于二维码模块定位区别
          },
          {
            tid: '1btc755snr6o00',
            lock: true,
            hidden: false,
            style: {
              'font-size': 20,
              'line-height': 26,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 28,
              top: 40,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: '#000',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="font-size: 20px;">长按识别二维码</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字5',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1,
            textType: 'shareTitle',
            blockType: 'qrCodeBlock' // 前端用于二维码模块定位区别
          },
          {
            tid: '1wjnnw6kxqrk00',
            lock: true,
            hidden: false,
            style: {
              'font-size': 14,
              'line-height': 18,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 29,
              top: 75,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: '#000',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '查看职位详情',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字6',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1,
            textType: 'shareText',
            blockType: 'qrCodeBlock' // 前端用于二维码模块定位区别
          },
          {
            tid: '5tebhmn0mmk004',
            lock: true,
            hidden: false,
            style: {
              position: 'absolute',
              width: 349.941,
              height: 523,
              left: 12,
              top: 20,
              'border-radius': 4,
              'border-width': 0,
              'border-style': 'solid',
              rotate: 0,
              transform: 'rotate(0deg)',
              'border-color': '',
              'clip-path': 'none',
              opacity: 1
            },
            link: null,
            filterType: 0,
            clipShape: '',
            cmpType: 'block',
            type: 'basic_block',
            name: '中间区块',
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            // qyCodeLayout: 'right',  // left right
            // qyCodelocation: 'top' // top bottom
          }
        ],
        bodyConfig:{
            bgimage: '',
            style: {
                position: 'relative',
                height: 523 ,
            },
            qyCodeLayout: 'right',  // left right
            qyCodelocation: 'top' // top bottom
        },
        headerConfig:{
            bgimage: 'https://img01.71360.com/w3/jj54ej/20231107/30aaaddfd5da58a1db66c8541bd67270.png',
            style: {
                position: 'relative',
                height: 94 ,
            },
            cmps: [
               
              {
                tid: '1507trtekvj400',
                lock: false,
                hidden: false,
                areaType:'header',
                style: {
                  position: 'absolute',
                  width: 65,
                  height: 65,
                  left: 27,
                  top: 20,
                  'border-radius': 72,
                  'border-width': 0,
                  'border-style': 'solid',
                  rotate: 0,
                  transform: 'rotate(0deg)',
                  'border-color': '',
                  'clip-path': 'none',
                  opacity: 1
                },
                file: {
                  key: '/img/poster/avatar.svg',
                  filtereffect: 'original',
                  a: null,
                  server: '',
                  orikey: '/img/poster/avatar.svg',
                  link: 'https://img01.71360.com/w3/jj54ej/20231107/d11943c5ea96545de7a58a4adb5b6e1d.png'
                },
                imgType: 'userProfile',
                link: null,
                filterType: 0,
                clipShape: '',
                fit: 'cover',
                cmpType: 'image',
                type: 'basic_image',
                name: '图片1',
                positionInfoList: [],
                shadow: {
                  x: 0,
                  y: 0,
                  blur: 0,
                  color: '#000'
                },
                canResize: true
              },
              {
                tid: '5tebhmn0mmk000',
                lock: false,
                hidden: false,
                areaType:'header',
                style: {
                  'font-size': 20,
                  'line-height': 26,
                  'letter-spacing': 0,
                  'font-family': 'font-25',
                  position: 'absolute',
                  left: 106,
                  top: 20,
                  rotate: 0,
                  height: 'auto',
                  transform: 'rotate(0deg)',
                  width: 200,
                  color: '#000',
                  background: 'transparent',
                  'text-align': 'left',
                  'text-decoration': 'none',
                  'font-weight': 'normal',
                  'font-style': 'normal',
                  font_family: 'font-25',
                  opacity: 1
                },
                text: '<span style="font-size: 20px; font-weight: bold;">门户名称</span>',
                link: null,
                textType: 'gatewayName',
                imageLink: '',
                mask: false,
                cmpType: 'text',
                type: 'basic_text',
                name: '文字2',
                _style: {
                  font_family: 'font-25',
                  'font-size': 14,
                  'line-height': 18,
                  width: 200
                },
                positionInfoList: [],
                isEditing: false,
                autoFixLayoutSize: true,
                shadow: {
                  x: 0,
                  y: 0,
                  blur: 0,
                  color: '#000'
                }
              },
              {
                tid: '254vp7roc7xc00',
                lock: false,
                hidden: false,
                areaType:'header',
                style: {
                  'font-size': 14,
                  'line-height': 18,
                  'letter-spacing': 0,
                  'font-family': 'font-25',
                  position: 'absolute',
                  left: 105,
                  top: 53,
                  rotate: 0,
                  height: 'auto',
                  transform: 'rotate(0deg)',
                  width: 200,
                  color: '#000',
                  background: 'transparent',
                  'text-align': 'left',
                  'text-decoration': 'none',
                  'font-weight': 'normal',
                  'font-style': 'normal',
                  font_family: 'font-25',
                  opacity: 1
                },
                text: '企业简称',
                link: null,
                textType: 'companyName',
                imageLink: '',
                mask: false,
                cmpType: 'text',
                type: 'basic_text',
                name: '文字3',
                _style: {
                  font_family: 'font-25',
                  'font-size': 14,
                  'line-height': 18,
                  width: 200
                },
                positionInfoList: [],
                isEditing: false,
                autoFixLayoutSize: true,
                shadow: {
                  x: 0,
                  y: 0,
                  blur: 0,
                  color: '#000'
                }
              },
            ]
        },
        footerConfig:{
            bgimage: '',
            style: {
                position: 'relative',
                height: 50 ,
            },
            cmps: [
                {
                    tid: '5tebhmn0mmk010',
                    lock: false,
                    hidden: false,
                    areaType:'footer',
                    style: {
                      'font-size': 14,
                      'line-height': 18,
                      'letter-spacing': 0,
                      'font-family': 'font-25',
                      position: 'absolute',
                      left: 106,
                      top: 20,
                      rotate: 0,
                      height: 'auto',
                      transform: 'rotate(0deg)',
                      width: 200,
                      color: '#000',
                      background: 'transparent',
                      'text-align': 'left',
                      'text-decoration': 'none',
                      'font-weight': 'normal',
                      'font-style': 'normal',
                      font_family: 'font-25',
                      opacity: 1
                    },
                    text: '门户名称',
                    link: null,
                    textType: 'gatewayName',
                    imageLink: '',
                    mask: false,
                    cmpType: 'text',
                    type: 'basic_text',
                    name: '文字2',
                    _style: {
                      font_family: 'font-25',
                      'font-size': 14,
                      'line-height': 18,
                      width: 200
                    },
                    positionInfoList: [],
                    isEditing: false,
                    autoFixLayoutSize: true,
                    shadow: {
                      x: 0,
                      y: 0,
                      blur: 0,
                      color: '#000'
                    }
                  }
            ]
        }
      },
      previewUrl: 'https://zzp-public-1318723636.cos.ap-shanghai.myqcloud.com/zhaopin/123456/2024/06/12/65aff2fea7e54fe7864400bdc775a7b0.png',
      posterName: '系统预置海报'
    },
    // 推荐码模板
    referralCode: {
      width:670,
      height: 1192,
      in: 'move',
      selectPosition: '1',
      pages: {
        id: '1toak7gbhwn400',
        row: 0,
        col: 0,
        in: null,
        out: null,
        bgcol: '',
        selectBgType: '2',
        bgimage: 'https://img01.71360.com/w3/jj54ej/20231107/ac6a011c0b861a8c3984551dec8355c8.png',
        bgserver: null,
        bgleft: 0,
        bgpositionx: 50,
        bgtop: 0,
        cmps: [
          {
            tid: '5bul8fanlzg000',
            lock: false,
            hidden: false,
            style: {
              position: 'absolute',
              width: 40.982600000000005,
              height: 40.982600000000005,
              left: 75,
              top: 348,
              'border-radius': 100,
              'border-width': 0,
              'border-style': 'solid',
              rotate: 0,
              transform: 'rotate(0deg)',
              'border-color': '',
              'clip-path': 'none',
              opacity: 1
            },
            file: {
              key: '/img/poster/avatar.svg',
              filtereffect: 'original',
              a: null,
              server: '',
              orikey: '/img/poster/avatar.svg',
              link: 'https://img01.71360.com/w3/jj54ej/20231107/d11943c5ea96545de7a58a4adb5b6e1d.png'
            },
            imgType: 'userProfile',
            link: null,
            filterType: 0,
            clipShape: '',
            fit: 'cover',
            cmpType: 'image',
            type: 'basic_image',
            name: '图片1',
            positionInfoList: [],
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            canResize: true
          },
          {
            tid: '4wgs37ptglu000',
            lock: false,
            hidden: false,
            style: {
              'font-size': 18,
              'line-height': 23,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 125,
              top: 345,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: 'rgba(53,53,53,1)',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="font-size: 18px; color: rgb(53, 53, 53);">门户名称</span>',
            link: null,
            textType: 'gatewayName',
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字2',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            tid: '3gfs7d1yfjw000',
            lock: false,
            hidden: false,
            style: {
              'font-size': 14,
              'line-height': 18,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 125,
              top: 371,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: 'rgba(75,75,75,1)',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="color: rgb(75, 75, 75);">企业简称</span>',
            link: null,
            textType: 'companyName',
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字3',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            tid: '1xus56do196o00',
            lock: false,
            hidden: false,
            style: {
              'font-size': 14,
              'line-height': 18,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 73,
              top: 436,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: 'rgba(33,33,33,1)',
              background: 'transparent',
              'text-align': 'center',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="color: rgb(33, 33, 33); font-size: 14px;">推荐码</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字4',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: -1
          },
          {
            tid: 'gd8x65u530000',
            lock: false,
            hidden: false,
            style: {
              position: 'absolute',
              width: 138,
              height: 138,
              left: 113,
              top: 463,
              'border-radius': 0,
              'border-width': 0,
              'border-style': 'solid',
              rotate: 0,
              transform: 'rotate(0deg)',
              'border-color': '',
              'clip-path': 'none',
              opacity: 1
            },
            file: {
              key: 'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp',
              filtereffect: 'original',
              a: null,
              server: '',
              orikey: 'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp'
            },
            imgType: 'qrCode',
            link: null,
            filterType: 0,
            clipShape: '',
            fit: 'cover',
            cmpType: 'image',
            type: 'basic_image',
            name: '图片5',
            positionInfoList: [],
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            canResize: true
          },
          {
            tid: '1ypab9gcfe9s00',
            lock: false,
            hidden: false,
            style: {
              'font-size': 24,
              'line-height': 31,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 74,
              top: 398,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: '#000',
              background: 'transparent',
              'text-align': 'center',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="font-size: 24px; font-weight: bold;">TJM123</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字6',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1
          }
        ],
        appid: '1ysx1cl7889s00',
        createtime: '2021-12-07T15:23:53.620Z',
        updatetime: '2021-12-07T15:23:53.620Z'
      },
      previewUrl: 'https://img01.71360.com/w3/jj54ej/20231107/b901ad230ee087ca2500fca35d5570b2.png',
      posterName: '系统预置海报'
    },
    // 外推海报
    extrapolation: {
      width: 670,
      height: 1192,
      in: 'move',
      selectPosition: '2',
      pages: {
        id: '1toak7gbhwn400',
        row: 0,
        col: 0,
        in: null,
        out: null,
        bgcol: '',
        selectBgType: '2',
        bgimage: 'https://img01.71360.com/w3/jj54ej/20231107/cacb8e26415f5837b3acc510cdacae5c.png',
        bgserver: null,
        bgleft: 0,
        bgpositionx: 50,
        bgtop: 0,
        cmps: [
          {
            tid: '5bul8fanlzg000',
            lock: false,
            hidden: false,
            style: {
              position: 'absolute',
              width: 39.9722,
              height: 39.9722,
              left: 40,
              top: 386,
              'border-radius': 100,
              'border-width': 0,
              'border-style': 'solid',
              rotate: 0,
              transform: 'rotate(0deg)',
              'border-color': '',
              'clip-path': 'none',
              opacity: 1
            },
            file: {
              key: '/img/poster/avatar.svg',
              filtereffect: 'original',
              a: null,
              server: '',
              orikey: '/img/poster/avatar.svg',
              link: 'https://img01.71360.com/w3/jj54ej/20231107/d11943c5ea96545de7a58a4adb5b6e1d.png'
            },
            imgType: 'userProfile',
            link: null,
            filterType: 0,
            clipShape: '',
            fit: 'cover',
            cmpType: 'image',
            type: 'basic_image',
            name: '图片1',
            positionInfoList: [],
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            canResize: true
          },
          {
            tid: '4wgs37ptglu000',
            lock: false,
            hidden: false,
            style: {
              'font-size': 18,
              'line-height': 23,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 95,
              top: 382,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: 'rgba(53,53,53,1)',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="font-size: 18px; color: rgb(53, 53, 53);">门户名称</span>',
            link: null,
            textType: 'gatewayName',
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字2',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            tid: '3gfs7d1yfjw000',
            lock: false,
            hidden: false,
            style: {
              'font-size': 14,
              'line-height': 18,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 95,
              top: 407,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: 'rgba(78,89,105,1)',
              background: 'transparent',
              'text-align': 'left',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="color: rgb(78, 89, 105);">企业简称</span>',
            link: null,
            textType: 'companyName',
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字3',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            }
          },
          {
            tid: '1xus56do196o00',
            lock: false,
            hidden: false,
            style: {
              'font-size': 14,
              'line-height': 18,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 90,
              top: 459,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: 'rgba(33,33,33,1)',
              background: 'transparent',
              'text-align': 'center',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="color: rgb(33, 33, 33); font-size: 14px;">推荐码</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字4',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: -1
          },
          {
            tid: 'gd8x65u530000',
            lock: false,
            hidden: false,
            style: {
              position: 'absolute',
              width: 101.98599999999999,
              height: 105.98599999999999,
              left: 140,
              top: 479,
              'border-radius': 0,
              'border-width': 0,
              'border-style': 'solid',
              rotate: 0,
              transform: 'rotate(0deg)',
              'border-color': '',
              'clip-path': 'none',
              opacity: 1
            },
            file: {
              key: 'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp',
              filtereffect: 'original',
              a: null,
              server: '',
              orikey: 'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp'
            },
            imgType: 'qrCode',
            link: null,
            filterType: 0,
            clipShape: '',
            fit: 'cover',
            cmpType: 'image',
            type: 'basic_image',
            name: '图片5',
            positionInfoList: [],
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            canResize: true
          },
          {
            tid: '1ypab9gcfe9s00',
            lock: false,
            hidden: false,
            style: {
              'font-size': 20,
              'line-height': 26,
              'letter-spacing': 0,
              'font-family': 'font-25',
              position: 'absolute',
              left: 90,
              top: 424,
              rotate: 0,
              height: 'auto',
              transform: 'rotate(0deg)',
              width: 200,
              color: '#000',
              background: 'transparent',
              'text-align': 'center',
              'text-decoration': 'none',
              'font-weight': 'normal',
              'font-style': 'normal',
              font_family: 'font-25',
              opacity: 1
            },
            text: '<span style="font-weight: bold; font-size: 20px;">TJM123</span>',
            link: null,
            imageLink: '',
            mask: false,
            cmpType: 'text',
            type: 'basic_text',
            name: '文字6',
            _style: {
              font_family: 'font-25',
              'font-size': 14,
              'line-height': 18,
              width: 200
            },
            positionInfoList: [],
            isEditing: false,
            autoFixLayoutSize: true,
            shadow: {
              x: 0,
              y: 0,
              blur: 0,
              color: '#000'
            },
            on_double_click: 1
          }
        ],
        appid: '1ysx1cl7889s00',
        createtime: '2021-12-07T15:23:53.620Z',
        updatetime: '2021-12-07T15:23:53.620Z'
      },
      previewUrl: 'https://img01.71360.com/w3/jj54ej/20231107/5da2162845694605291b33a78a1d507d.png',
      posterName: '系统预置海报'
    },
    // 运营活动海报
    operatingActivities:{
        "height": 667,
        "width": 1192,
        "in": "move",
        "pages": {
            "bgcol": "rgba(255,255,255,1)",
            "bgimage": "https://img01.71360.com/w3/jj54ej/20231107/cfac6e6996d139b7e6d17127afb74466.png",
            "selectBgType": "2",
            "cmps": [
                {
                    "canResize": true,
                    "clipShape": "",
                    "cmpType": "image",
                    "file": {
                        "a": null,
                        "filtereffect": "original",
                        "key": "https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp",
                        "orikey": "https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp",
                        "server": ""
                    },
                    "filterType": 0,
                    "fit": "cover",
                    "hidden": false,
                    "link": null,
                    "lock": false,
                    "name": "图片3",
                    "positionInfoList": [],
                    "imgType": "qrCode",
                    "style": {
                        "border-color": "",
                        "border-radius": 0,
                        "border-style": "solid",
                        "border-width": 0,
                        "clip-path": "none",
                        "height": 131,
                        "left": 45,
                        "opacity": 1,
                        "position": "absolute",
                        "rotate": 0,
                        "top": 212,
                        "transform": "rotate(0deg)",
                        "width": 131
                    },
                    "tid": "510df97ra58000",
                    "type": "basic_image",
                    "shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "color": "#000"
                    }
                },
                {
                    "autoFixLayoutSize": true,
                    "canResize": false,
                    "on_double_click": 1,
                    "cmpType": "text",
                    "hidden": false,
                    "imageLink": "",
                    "isEditing": false,
                    "link": null,
                    "lock": false,
                    "mask": false,
                    "name": "文字4",
                    "positionInfoList": [],
                    "style": {
                        "background": "transparent",
                        "color": "rgba(255,255,255,1)",
                        "font-family": "font-25",
                        "font-size": 14,
                        "font_family": "font-25",
                        "height": 36,
                        "left": 43,
                        "letter-spacing": 0,
                        "line-height": 18,
                        "opacity": 1,
                        "position": "absolute",
                        "rotate": 0,
                        "text-align": "center",
                        "text-decoration": "none",
                        "font-weight": "normal",
                        "font-style": "normal",
                        "top": 380,
                        "transform": "rotate(0deg)",
                        "width": 144
                    },
                    "text": "<span style=\"color: rgb(255, 255, 255);\">长按识别二维码</span><div><span style=\"color: rgb(255, 255, 255);\">查看更多信息</span></div>",
                    "textType": "",
                    "tid": "1b8lv2ne6dmo00",
                    "type": "basic_text",
                    "_style": {
                        "font-size": 14,
                        "font_family": "font-25",
                        "line-height": 18,
                        "width": 200
                    },
                    "shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "color": "#000"
                    }
                },
                {
                    "autoFixLayoutSize": true,
                    "cmpType": "text",
                    "hidden": false,
                    "imageLink": "",
                    "isEditing": false,
                    "link": null,
                    "lock": false,
                    "mask": false,
                    "name": "文字1",
                    "positionInfoList": [],
                    "style": {
                        "background": "transparent",
                        "color": "rgba(255,255,255,1)",
                        "font-family": "font-25",
                        "font-size": 30,
                        "font-weight": "bold",
                        "font_family": "font-25",
                        "height": "auto",
                        "left": 45,
                        "letter-spacing": 0,
                        "line-height": 36,
                        "opacity": 1,
                        "position": "absolute",
                        "rotate": 0,
                        "text-align": "left",
                        "font-style": "normal",
                        "top": 104,
                        "transform": "rotate(0deg)",
                        "width": 200
                    },
                    "text": "<span style=\"color: rgb(255, 255, 255);\">系统预置活动</span>",
                    "textType": "companyName",
                    "tid": "4l3vc5psv7s000",
                    "type": "basic_text",
                    "_style": {
                        "font-size": 30,
                        "font-weight": "bold",
                        "font_family": "font-25",
                        "line-height": 36,
                        "width": 200
                    },
                    "shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "color": "#000"
                    }
                }
            ]
        },
        "selectPosition": "1",
        "previewUrl": "https://img01.71360.com/w3/jj54ej/20240124/98831a3a05921c502723f7ab74653f83.png",
        "posterName": "系统预置海报"
    }
  }
}
